// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"ae01ac89","483":"f0ea3cf9","543":"aa78d258","901":"d17fec25","933":"c5d68074"}[chunkId] + ".chunk.css";
};